module.exports = __webpack_public_path__ + "static/media/Venice.2ffe901b.jpg";